import { useState } from 'react';
import { PasswordSaved } from './PasswordSaved';
import { MFAForm } from './MFAForm';
import { PasswordForm } from './PasswordForm';
import { ResetPasswordContext } from './context';

const STEP_LIMIT = 2;

const renderStep = (step: number) => {
  switch (step) {
    case 2:
      return <PasswordSaved />;
    case 1:
      return <MFAForm />;
    case 0:
    default:
      return <PasswordForm />;
  }
};

export const ResetPassword = () => {
  const [step, setStep] = useState<number>(0);
  const [mfaToken, setMFAToken] = useState<string>('');
  const [mfaType, setMFAType] = useState<string>('');
  const [maskedPhoneNumber, setMaskedPhoneNumber] = useState<string>('');

  const goToPreviousStep = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  const goToNextStep = () => {
    if (step < STEP_LIMIT) {
      setStep(step + 1);
    }
  };

  const contextValues = {
    step,
    goToNextStep,
    goToPreviousStep,
    mfaToken,
    setMFAToken,
    mfaType,
    setMFAType,
    maskedPhoneNumber,
    setMaskedPhoneNumber,
  };

  return (
    <ResetPasswordContext.Provider value={contextValues}>
      {renderStep(step)}
    </ResetPasswordContext.Provider>
  );
};
